import { useMemo } from 'react';
import type { Branch } from '../../../../../@types/Branch';
import type { RequestStateQuery } from '../../../../../@types/RequestStateQuery';
import useBranches from '../../../../../data/branch/useBranches';
import useAuth from '../../../../../hooks/useAuth';
import { escapeRegExpString } from '../../../../../utils/formats';

const filterBranch = (branch: Branch, filter?: string) => {
  if (!filter) {
    return true;
  }

  const reg = new RegExp(`(${escapeRegExpString(filter)})`, 'gi');

  return branch.name && reg.test(branch.name);
};

const useSearchBranches = (filter?: string): [Branch[] | undefined, RequestStateQuery] => {
  const { isAdmin } = useAuth();
  const [branches, request] = useBranches();

  const filteredBranches = useMemo(
    (): Branch[] | undefined =>
      isAdmin ? branches : branches?.filter((b) => filterBranch(b, filter)),
    [branches, filter, isAdmin],
  );

  return [filteredBranches, request];
};

export default useSearchBranches;
